var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"background-color":"#DAF7F7"}},[_c('FirstSection'),_c('SecondSection'),_c('ThirdSection'),_c('FourthSection'),_c('FifhtSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }